import type { Location as RouterLocation } from 'react-router';
import { z } from 'zod';

/**
 * Router state Sean leaves when an action opens a page: the control there to
 * bring into view. The session provider writes it and the app layout reads it
 * back from the location, which can also hold state another page wrote.
 */
const folioNavigationStateSchema = z.object({
  folio_target_highlight: z.object({
    target_test_id: z.string().min(1),
    // Nothing reads these yet, so one that cannot be read does not stop the highlight.
    page_id: z.string().optional().catch(undefined),
    page_name: z.string().optional().catch(undefined),
  }),
});

export type FolioNavigationState = z.input<typeof folioNavigationStateSchema>;
type FolioTargetHighlight = z.output<typeof folioNavigationStateSchema>['folio_target_highlight'];

export function readFolioTargetHighlight(state: RouterLocation['state']): FolioTargetHighlight | null {
  const navigation = folioNavigationStateSchema.safeParse(state);
  return navigation.success ? navigation.data.folio_target_highlight : null;
}
